import { render, staticRenderFns } from "./InvoiceBreakdownTable.vue?vue&type=template&id=0c215199&scoped=true"
import script from "./InvoiceBreakdownTable.vue?vue&type=script&lang=js"
export * from "./InvoiceBreakdownTable.vue?vue&type=script&lang=js"
import style0 from "./InvoiceBreakdownTable.vue?vue&type=style&index=0&id=0c215199&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c215199",
  null
  
)

export default component.exports